var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { themeLss } from "../../lss";
import styled from "../../styled";
export var TextInputIcon = styled.span(themeLss(function (_a) {
    var position = _a.position, isIconBgTransparent = _a.isIconBgTransparent, _b = _a.lss, lss = _b === void 0 ? {} : _b;
    return (__assign({ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', height: '100%', minHeight: '38px', border: 'none', outline: 'none', fontSize: 'content', color: !isIconBgTransparent ? 'primary500' : 'gray700', px: 'md', bg: isIconBgTransparent ? 'transparent' : 'gray200', borderRight: !isIconBgTransparent && position === 'left' ? 'regular' : 'none', borderLeft: !isIconBgTransparent && position === 'right' ? 'regular' : 'none', userSelect: 'none', '-webkit-tap-highlight-color': 'transparent', '::selection': {
            background: 'transparent'
        } }, lss));
}));
//# sourceMappingURL=TextInputIcon.js.map